import { Route, Routes } from 'react-router-dom';
import { AppShell } from './components/layout/Layout';
import HomePage from './pages/HomePage';

export default function App() {
  return <AppShell><Routes><Route path="*" element={<HomePage />} /></Routes></AppShell>;
}
